(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-thumbnail"] && !Shopify.designMode) return;
  try {
    document.addEventListener("contextmenu", e => e.preventDefault());
  document.onkeydown = function(e) {
    if(e.keyCode == 123) return false;
    if(e.ctrlKey && e.shiftKey && e.keyCode == 73) return false;
    if(e.ctrlKey && e.shiftKey && e.keyCode == 74) return false;
    if(e.ctrlKey && e.keyCode == 85) return false;
  };
  document.addEventListener("dragstart", function(e){
    e.preventDefault();
  });
  document.querySelectorAll("img").forEach(img => {
    img.setAttribute("draggable", "false");
    img.style.pointerEvents = "none"; 
  });
  } catch(e) { console.error(e); }
})();

})();
